export default {
  trainingClass_recent_released: 'Recent Releases',
  trainingClass_check_train: '1202Web-View training classes',
  trainingClass_show_train: '1201Web-Display training class list',
  trainingClass_portal_train: '12Web-Smart portal training class',
  trainingClass_all_months: 'All months',
  trainingClass_year_mouths: '{year}-{MM}',
}
